import { render, staticRenderFns } from "./AdminRoleKey.vue?vue&type=template&id=19f448f9&"
import script from "./AdminRoleKey.vue?vue&type=script&lang=js&"
export * from "./AdminRoleKey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19f448f9')) {
      api.createRecord('19f448f9', component.options)
    } else {
      api.reload('19f448f9', component.options)
    }
    module.hot.accept("./AdminRoleKey.vue?vue&type=template&id=19f448f9&", function () {
      api.rerender('19f448f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/AdminRoleKey.vue"
export default component.exports